import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReplyUpdateModel } from '@sb-tools/typescript/models/reply-update-model.model';
import { environment } from '@environment';
import { MessageDTO } from '@sb-tools/typescript/models/dto/message.dto';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { ThreadElementDTO } from '@sb-tools/typescript/models/dto/thread-element.dto';
import { EmailRecipients } from '../../../core/models/email-recipients.model';
import { ReplyDeletedDTO } from '../../models/dto/reply-deleted-dto';
import { Tag } from '@sb-tools/typescript/models/tag.model';
import { TagDTO } from '@sb-tools/typescript/models/dto/tag.dto';

@Injectable({
    providedIn: 'root',
})
export class ReplyDataService {
    constructor(private httpClient: HttpClient) {}

    addPrivateReplyForReply(ticketId: number, replyId: number, replyModel: ReplyUpdateModel): Observable<number> {
        // response type long
        return this.httpClient.post<number>(
            `${environment.apiInboxUrl}tickets/${ticketId}/replies/${replyId}/addPrivateReply`,
            replyModel,
        );
    }

    addPrivateReplyForTicket(ticketId: number, replyModel: ReplyUpdateModel): Observable<number> {
        return this.httpClient.post<number>(
            `${environment.apiInboxUrl}tickets/${ticketId}/addPrivateReply`,
            replyModel,
        ); // response type long
    }

    addReply(ticketId: number, newReply: ReplyUpdateModel): Observable<ThreadElementDTO> {
        return this.httpClient.post<ThreadElementDTO>(
            `${environment.apiInboxUrl}tickets/${ticketId}/replies`,
            newReply,
        );
    }

    deleteReply(ticketId: number, parentReplyId: number, replyId: number): Observable<ReplyDeletedDTO> {
        return this.httpClient.delete<ReplyDeletedDTO>(
            `${environment.apiInboxUrl}tickets/${ticketId}/replies/${replyId}?parentId=${parentReplyId}`,
        );
    }

    getOriginalMessage(ticketId: number, replyId: number): Observable<MessageDTO> {
        return this.httpClient.get<MessageDTO>(
            `${environment.apiInboxUrl}tickets/${ticketId}/replies/${replyId}/originalMessage`,
        );
    }

    handleReply(ticketId: number, replyId: number, isHandled: boolean): Observable<BaseUserWithRole> {
        return this.httpClient.patch<BaseUserWithRole>(
            `${environment.apiInboxUrl}tickets/${ticketId}/replies/${replyId}/Handle?isHandled=${isHandled}`,
            null,
        );
    }

    hideReply(
        ticketId: number,
        replyId: number,
        isVisible: boolean,
        isSubreply: boolean,
        isUserBlocked: boolean,
    ): Observable<ThreadElementDTO> {
        return this.httpClient.patch<ThreadElementDTO>(
            `${environment.apiInboxUrl}tickets/${ticketId}/replies/${replyId}/Visibility`,
            null,
            { params: { isVisible, isSubreply, isUserBlocked } },
        );
    }

    updateReply(ticketId: number, replyId: number, replyModel: ReplyUpdateModel): Observable<ThreadElementDTO> {
        return this.httpClient.patch<ThreadElementDTO>(
            `${environment.apiInboxUrl}tickets/${ticketId}/replies/${replyId}`,
            replyModel,
        );
    }

    updateTags(ticketId: number, replyId: number, tags: Tag[]): Observable<TagDTO[]> {
        return this.httpClient.put<TagDTO[]>(
            `${environment.apiInboxUrl}tickets/${ticketId}/replies/${replyId}/tags`,
            tags,
        );
    }

    validateReplyRecipients(ticketId: number, emailRecipients: EmailRecipients): Observable<boolean> {
        return this.httpClient.post<boolean>(
            `${environment.apiInboxUrl}tickets/${ticketId}/ValidateReplyRecipients`,
            emailRecipients,
        );
    }
}
